import { GameTemplate, ObjectId, Stored } from "../types";
import ApiModule from "./base";

export type GameTemplateParams = Omit<
  Omit<Omit<Omit<GameTemplate, "deleted">, "default">, "type">,
  "createdBy"
>;

export default class GameTemplateSModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "game_templates");
  }

  async index(): Promise<Array<Stored<GameTemplate>>> {
    const request = new Request(this.url, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async create(template: GameTemplateParams): Promise<Stored<GameTemplate>> {
    const request = new Request(this.url, {
      method: "POST",
      headers: this._defaultHeaders(),
      body: JSON.stringify(template),
    });
    return await this._resolve(request);
  }

  async read(id: ObjectId): Promise<Stored<GameTemplate>> {
    const request = new Request(`${this.url}/${id}`, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async update(
    id: ObjectId,
    block: GameTemplateParams,
  ): Promise<Stored<GameTemplate>> {
    const request = new Request(`${this.url}/${id}`, {
      method: "PATCH",
      headers: this._defaultHeaders(),
      body: JSON.stringify(block),
    });
    return await this._resolve(request);
  }

  async destroy(id: ObjectId): Promise<Stored<GameTemplate>> {
    const request = new Request(`${this.url}/${id}`, {
      method: "DELETE",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }
}
